import { AdmissionSghscComponent } from './components/pages/admission-sghsc/admission-sghsc.component';
import { DynamicNewsAndEventComponent } from './components/pages/dynamic-news-and-event/dynamic-news-and-event.component';
import { TemplatePageComponent } from './components/pages/template-page/template-page.component';
import { AcademicWingsCollegeComponent } from './components/pages/academic-wings-college/academic-wings-college.component';
import { AcademicWingsBanglaVersionComponent } from './components/pages/academic-wings-bangla-version/academic-wings-bangla-version.component';
import { AcademicWingsEnglishVersionComponent } from './components/pages/academic-wings-english-version/academic-wings-english-version.component';
import { LeadershipComponent } from './components/pages/leadership/leadership.component';

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeDemoEightComponent } from './components/pages/home-demo-eight/home-demo-eight.component';
import { HomeDemoTwelveComponent } from './components/pages/home-demo-twelve/home-demo-twelve.component';
import { HomeComponent } from './components/pages/home/home.component';
import { NotFoundComponent } from './components/pages/not-found/not-found.component';
import { NoticeComponent } from './components/pages/notice/notice.component';
import { AboutAsideComponent } from './components/pages/about-aside/about-aside.component';
import { DwClubComponent } from './components/pages/dw-club/dw-club.component';
import { AdministrationComponent } from './components/pages/administration/administration.component';
import { AcademicAsideComponent } from './components/pages/academic-aside/academic-aside.component';
import { NewAndEventsItemsComponent } from './components/pages/new-and-events-items/new-and-events-items.component';
import { NewAndEventsComponent } from './components/pages/new-and-events/new-and-events.component';
import { ImageFolderComponent } from './components/pages/image-folder/image-folder.component';
import { VideoFolderComponent } from './components/pages/video-folder/video-folder.component';
import { ImageGalleryComponent } from './components/pages/image-gallery/image-gallery.component';
import { VideoGalleryComponent } from './components/pages/video-gallery/video-gallery.component';
import { LibraryComponent } from './components/pages/library/library.component';
import { ComputerClubComponent } from './components/pages/computer-club/computer-club.component';
import { PhysicsLabComponent } from './components/pages/physics-lab/physics-lab.component';
import { ChemistryLabComponent } from './components/pages/chemistry-lab/chemistry-lab.component';
import { MultimediaClassroomComponent } from './components/pages/multimedia-classroom/multimedia-classroom.component';
import { AchievementsComponent } from "./components/pages/achievements/achievements.component";
import { AchievementsItemComponent } from "./components/pages/achievements-item/achievements-item.component";
import { AllChiefPatronsComponent } from './components/pages/all-chief-patrons/all-chief-patrons.component';
import { AllChairmansComponent } from './components/pages/all-chairmans/all-chairmans.component';
import { AllPrincipalsComponent } from './components/pages/all-principals/all-principals.component';
import { TeacherInformationComponent } from './components/pages/teacher-information/teacher-information.component';
import { StaffInformationComponent } from './components/pages/staff-information/staff-information.component';

const routes: Routes = [
    { path: '', component: HomeComponent },
    { path: 'home', component: HomeComponent },
    { path: 'video-gallery', component: VideoGalleryComponent },
    { path: 'all-chief-patrons', component: AllChiefPatronsComponent },
    { path: 'all-chairmans', component: AllChairmansComponent },
    { path: 'all-principals', component: AllPrincipalsComponent },
    { path: 'teacher-information', component: TeacherInformationComponent },
    { path: 'staff-information', component: StaffInformationComponent },
    { path: "leadership", component: LeadershipComponent },
    { path: "exam-routine", component: TemplatePageComponent },
    { path: "student-statistics", component: TemplatePageComponent },
    { path: "safety-&-security", component: TemplatePageComponent },
    { path: "class-routine", component: TemplatePageComponent },
    { path: "hsc-results", component: TemplatePageComponent },
    { path: "admit-card", component: TemplatePageComponent },
    
{ path: "history", component: TemplatePageComponent },
{ path: "why-study", component: TemplatePageComponent },
{ path: "mission-and-vision", component: TemplatePageComponent },
{ path: "infustructure", component: TemplatePageComponent },
{ path: "syllabus", component: TemplatePageComponent },
{ path: "academic-calendar", component: TemplatePageComponent },
{ path: "text-book", component: TemplatePageComponent },
{ path: "internal-exam", component: TemplatePageComponent },
{ path: "online-apply", component: TemplatePageComponent },
{ path: "public-exam", component: TemplatePageComponent },
{ path: "hostel", component: TemplatePageComponent },
{ path: "canteen", component: TemplatePageComponent },
{ path: "classrooms", component: TemplatePageComponent },
{ path: "ict-lab", component: TemplatePageComponent },
{ path: "science-lab", component: TemplatePageComponent },
{ path: "library", component: TemplatePageComponent },
{ path: "auditorium", component: TemplatePageComponent },
{ path: "transportation", component: TemplatePageComponent },
{ path: "mosque", component: TemplatePageComponent },
{ path: "bangla-debate-club", component: TemplatePageComponent },
{ path: "cultural-club", component: TemplatePageComponent },
{ path: "sports-activities", component: TemplatePageComponent },
{ path: "science-club", component: TemplatePageComponent },
{ path: "bncc-activities", component: TemplatePageComponent },
{ path: "language-club", component: TemplatePageComponent },
{ path: "it-club", component: TemplatePageComponent },
{ path: "arts-craft-club", component: TemplatePageComponent },
{ path: "general-knowledge-club", component: TemplatePageComponent },
{ path: "rover-scout-activities", component: TemplatePageComponent },
{ path: "picnic-activities", component: TemplatePageComponent },
{ path: "college", component: TemplatePageComponent },
{ path: "academic-wings-college", component: AcademicWingsCollegeComponent },
{ path: "academic-wings-bangla-version", component: AcademicWingsBanglaVersionComponent },
{ path: "academic-wings-english-version", component: AcademicWingsEnglishVersionComponent },
{ path: "english-version", component: TemplatePageComponent },
{ path: "class-routine-college", component: TemplatePageComponent },
{ path: "class-routine-bangla-version", component: TemplatePageComponent },
{ path: "class-routine-english-version", component: TemplatePageComponent },
{ path: "exam-routine-college", component: TemplatePageComponent },
{ path: "exam-routine-bangla-version", component: TemplatePageComponent },
{ path: "exam-routine-english-version", component: TemplatePageComponent },
{ path: "college-syllabus", component: TemplatePageComponent },
{ path: "syllabus-bangla-version", component: TemplatePageComponent },
{ path: "syllabus-english-version", component: TemplatePageComponent },
 { path: "recruitment-result", component: TemplatePageComponent },
  { path: "health-care-center", component: TemplatePageComponent },

    { path: "ssc-results", component: TemplatePageComponent },
    { path: "science-club-physics", component: TemplatePageComponent },
    { path: "science-club-biology", component: TemplatePageComponent },
    { path: "science-club-chemistry", component: TemplatePageComponent },
    { path: "science-club-math", component: TemplatePageComponent },
    { path: "bangla-language-club", component: TemplatePageComponent },
    { path: "english-language-club", component: TemplatePageComponent },
    { path: "drama-club", component: TemplatePageComponent },
    { path: "music-club", component: TemplatePageComponent },
    { path: "dance-club", component: TemplatePageComponent },
    { path: "bangla-debate-club", component: TemplatePageComponent },
    { path: "english-debate-club", component: TemplatePageComponent },
    { path: "boys-hostel", component: TemplatePageComponent },
    { path: "girls-hostel", component: TemplatePageComponent },
    { path: "national", component: TemplatePageComponent },
    { path: "international", component: TemplatePageComponent },
    { path: "golden-jubile", component: TemplatePageComponent },
    { path: "on-campus", component: TemplatePageComponent }, // On Campus
    { path: "visitors", component: HomeDemoEightComponent }, // visitors
    { path: "student-corner", component: TemplatePageComponent },
    { path: "admission-circular", component: TemplatePageComponent },
    { path: "bangla-version", component: TemplatePageComponent },
    { path: "english-version", component: TemplatePageComponent },
    { path: "magazine", component: TemplatePageComponent },
    { path: "library", component: LibraryComponent },
    { path: "multimedia-classroom", component: MultimediaClassroomComponent },
    { path: "chemistry-lab", component: ChemistryLabComponent },
    { path: "physics-lab", component: PhysicsLabComponent },
    { path: "computer-lab", component: ComputerClubComponent},
  
{ path: "magazine", component: TemplatePageComponent },

    // { path: "new_news", component: DynamicNewsAndEventComponent },
    { path: "contact", component: HomeDemoTwelveComponent }, // nav bar contact
    {
        path: "administration",
        children: [
            { path: "", component: AdministrationComponent },
            { path: ":item", component: AdministrationComponent },
        ],
    },
    {
        path: "news-and-events",
        children: [
            { path: "", component: NewAndEventsComponent },
            { path: ":ItemId", component: NewAndEventsItemsComponent },
        ],
    },
    { path: "notice", component: NoticeComponent },
    {
        path: "clubs",
        children: [
            { path: "", component: DwClubComponent },
            { path: ":item", component: DwClubComponent },
        ],
    },
    { path: "photo-gallery", component: ImageGalleryComponent },
    { path: "video-gallery", component: VideoGalleryComponent },
    {
        path: "imageFolder",
        children: [
            { path: "", component: ImageFolderComponent },
            { path: ":folderId", component: ImageFolderComponent },
        ],
    },
    {
        path: "videoFolder",
        children: [
            { path: "", component: VideoFolderComponent },
            { path: ":folderId", component: VideoFolderComponent },
        ],
    },
    {
        path: "academic",
        children: [
            { path: "", component: AcademicAsideComponent },
            { path: ":item", component: AcademicAsideComponent },
        ],
    },

    { path: "admission", component: AdmissionSghscComponent }, //admission
    { path: "admission-details", component: AdmissionSghscComponent }, //admission
    { path: "admission-form", component: TemplatePageComponent },

    {
        path: "about",
        children: [
            { path: "", component: AboutAsideComponent },
            { path: ":item", component: AboutAsideComponent },
        ],
    },
    {
        path: "news",
        children: [
            { path: "", component: DynamicNewsAndEventComponent },
            { path: ":item", component: DynamicNewsAndEventComponent },
        ],
    },
    {
    path: "achievements",
    children: [
      { path: "", component: AchievementsComponent },
      { path: ":ItemId", component: AchievementsItemComponent },
    ],
  },

    // Here add new pages component

    { path: "**", component: NotFoundComponent }, // This line will remain down from the whole pages component list
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
